(() => {
  'use strict';
  const element = document.getElementById('CurrencyDisplayConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  if (config.base === config.quote) return;
  const note = document.querySelector('[data-currency-note]');
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: config.quote, currencyDisplay: 'code'});
  let rate;
  let rateDate;
  let queued = false;
  function render() {
    queued = false;
    if (!rate) return;
    document.querySelectorAll('[data-display-money]').forEach(node => {
      const amount = Number(node.dataset.money);
      let estimate = node.querySelector('[data-local-estimate]');
      if (!node.hasAttribute('data-money') || node.dataset.money === '' || !Number.isFinite(amount) || node.dataset.baseCurrency !== config.base) {
        estimate?.remove();
        return;
      }
      const label = config.approx + ' ' + formatter.format(amount / 100 * rate);
      if (!estimate) {
        estimate = document.createElement('small');
        estimate.className = 'local-price-estimate';
        estimate.dataset.localEstimate = '';
        node.append(estimate);
      }
      if (estimate.textContent !== label) estimate.textContent = label;
      if (estimate.title !== rateDate) estimate.title = rateDate;
    });
  }
  function schedule() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(render);
    }
  }
  async function start() {
    const key = 'copriva:fx:' + config.base + ':' + config.quote;
    let data;
    let fetched = false;
    try {
      const cached = JSON.parse(localStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.savedAt < 86400000) data = cached.value;
    } catch {}
    try {
      if (!data) {
        const response = await fetch('https://api.frankfurter.dev/v2/rate/' + encodeURIComponent(config.base) + '/' + encodeURIComponent(config.quote), {signal: AbortSignal.timeout(6000), credentials: 'omit', referrerPolicy: 'no-referrer'});
        if (!response.ok) throw new Error();
        data = await response.json();
        fetched = true;
      }
      if (data.base !== config.base || data.quote !== config.quote || !Number.isFinite(data.rate) || data.rate <= 0 || !/^\d{4}-\d{2}-\d{2}$/.test(data.date) || Date.now() - Date.parse(data.date) > 604800000) throw new Error();
      rate = data.rate;
      rateDate = data.date;
      if (fetched) { try { localStorage.setItem(key, JSON.stringify({savedAt: Date.now(), value: data})); } catch {} }
      if (note) note.textContent = config.note;
      render();
      new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true, characterData: true});
    } catch {
      if (note) note.textContent = config.unavailable;
    }
  }
  start();
})();
